<template>
  <table id="tabCluster">
    <tr>
      <td class="desc-title headTd">{{ $t("message.callStation") }}</td>
      <td class="headTd" colspan="2">PRA-CSLD / PRA-CSLW</td>
    </tr>
    <tr>
      <td>{{ $t("message.callStationDesktop") }}</td>
      <td class="device-content">PRA-CSLD

        <md-avatar v-if="(Number(desktop) + Number(wallmount)) > 2" style="width: 16px;min-width: 22px;height: 16px;">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-square-fill" viewBox="0 0 16 16" style="margin-right: 0px; color: #3ba3ff;cursor: pointer;width:18px;position: relative;top: 0px;">
          <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.93 4.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
          </svg>
          <md-tooltip md-direction="right" class="tooltipImg" style="transition-delay: 0ms;width: 485px;height: 60px;position: absolute;top: 520px;left: 670px;will-change: top, left;font-size: 16px;">
            <!-- <h4 style="font-size: 15px;padding: 4px;"></h4> -->
            Uwaga! Każdy zasilacz MPS ma 2 porty PoE.<br>Wymagane są dodatkowe porty PoE (dodaj np. Switch).
          </md-tooltip>
        </md-avatar>

      </td>
      <td class="qty-content">
        <input type="number" class="form-control form-control-sm" min=0 max=2
        v-model.lazy="desktop" @change="inputValue()"/>
      </td>
    </tr>
    <tr>
      <td>{{ $t("message.callStationWall") }}</td>
      <td class="device-content">PRA-CSLW</td>
      <td class="qty-content">
        <input type="number" class="form-control form-control-sm" min=0 max=2
        v-model.lazy="wallmount" @change="inputValue()"/>
      </td>
    </tr>
    <tr>
      <td>{{ $t("message.callStationExt") }}</td>
      <td class="device-content">PRA-CSE</td>
      <td class="qty-content">
        <input type="number" class="form-control form-control-sm" min=0 :max="maxExt"
        v-model.lazy="extension" @change="inputValue()"/>
      </td>
    </tr>
    <tr>
      <td></td>
      <td class="device-content">{{ $t("message.totalPoeCST") }}</td>
      <td class="qty-content">
        <input type="number" class="form-control form-control-sm" :min="minPoE" :max="maxPoE"
        v-model.lazy="poe" @change="inputValue()"/>
      </td>
    </tr>
    <tr>
      <td></td>
      <td class="device-content">{{ $t("message.classEmerdencyCST") }}</td>
      <td class="qty-content">
        <input type="number" class="form-control form-control-sm" min=0 :max="maxCst"
        v-model.lazy="cst" @change="inputValue()"/>
      </td>
    </tr>
    <tr class="wiersz-pusty"></tr>
  </table>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CallStation',
  props: ['title', 'values', 'clear'],
  data () {
    return {
      desktop: 0,
      wallmount: 0,
      extension: 0,
      poe: 0,
      cst: 0
    }
  },
  watch: {
    clearing (newValue, oldValue) {
      if (newValue === true) {
        this.desktop = 0
        this.wallmount = 0
        this.extension = 0
        this.poe = 0
        this.cst = 0
      }
    },
    clear (newValue, oldValue) {
      if (newValue === true) {
        this.desktop = 0
        this.wallmount = 0
        this.extension = 0
        this.poe = 0
        this.cst = 0
      }
    },
    values (newValue, oldValue) {
      if (newValue !== null) {
        this.desktop = this.values.csDesktop
        this.wallmount = this.values.csWall
        this.extension = this.values.csExt
        this.poe = this.values.poePorts
        this.cst = this.values.cstEmergency
      }
    },
    desktop (newValue, oldValue) {
      this.poe = Number(newValue) + Number(this.wallmount)
    },
    wallmount (newValue, oldValue) {
      this.poe = Number(newValue) + Number(this.desktop)
    }
  },
  computed: {
    ...mapGetters('app', ['clearing']),
    maxExt () {
      return (Number(this.desktop) + Number(this.wallmount)) * 4
    },
    minPoE () {
      return (Number(this.desktop) + Number(this.wallmount))
    },
    maxPoE () {
      return (Number(this.desktop) + Number(this.wallmount)) * 2
    },
    maxCst () {
      return (Number(this.desktop) + Number(this.wallmount))
    }
  },
  methods: {
    inputValue () {
      this.$emit('allValues', this.desktop, this.wallmount, this.extension, this.poe, this.cst)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Devices/CallStation.vue